import { ActionCreator } from 'redux'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { ProjectsApi } from '../../../api/projectApi'
import { toastMsg } from '../../../components/Toast/toastMsg'
import { IPagination } from '../../../types/pagination'
import { ProjectsState } from '../reducers'
import {
  ICostFilter,
  ICostFilterOption,
  ICostHistory,
  ICostSearch,
  ICostSorting,
  IDirectCost,
  IMilestone,
  IMilestoneOfferDirectCost,
  IMilestoneOfferDirectCostMonths,
  IMilestoneOfferDirectCostUpdate,
  IMilestoneSortColumn,
  IOfferDirectCost,
  IOfferPassThroughCost,
  IPassThroughCost
} from '../types/directAndPassTroughCosts'
import {
  IDirectCostsBulk,
  ILabelMergeTasksBulk,
  IOfferDirectCostsBulk,
  IOfferPassThroughCostsBulk,
  IPassTroughCostsBulk,
  IProjectOffer
} from './../types/project'
import * as constants from './constants'

export type DirectAndPassTroughCostThunkResult<R> = ThunkAction<Promise<R>, ProjectsState, null, DirectAndPassTroughCostActions>
export type DirectAndPassTroughCostThunkDispatchType = ThunkDispatch<ProjectsState, null, DirectAndPassTroughCostActions>

export interface CostsHasErrored {
  type: constants.COST_HAS_ERRORED
  hasErrored: boolean
}

export interface GetDirectCostsSuccess {
  type: constants.GET_DIRECT_COSTS_SUCCESS
  direct_costs: IDirectCost[]
}

export interface GetPaginatedDirectCostsSuccess {
  type: constants.GET_PAGINATED_DIRECT_COSTS_SUCCESS
  direct_costs: IPagination<IDirectCost[]>
}

export interface SetPaginatedDirectCostsActivePage {
  type: constants.SET_PAGINATED_DIRECT_COSTS_ACTIVE_PAGE
  page: number
}

export interface GetPassTroughCostsSuccess {
  type: constants.GET_PASS_TROUGH_COSTS_SUCCESS
  pass_trough_costs: IPassThroughCost[]
}

export interface GetDirectCostSuccess {
  type: constants.GET_DIRECT_COST_SUCCESS
  cost: IDirectCost
}

export interface GetPassTroughCostSuccess {
  type: constants.GET_PASS_TROUGH_COST_SUCCESS
  cost: IPassThroughCost
}

export interface SetSelectedCost {
  type: constants.SET_SELECTED_COST
  cost: IDirectCost | IPassThroughCost
}

export interface SetCostsFilters {
  type: constants.SET_COSTS_FILTERS
  filter: ICostFilter
  queryOptions: ICostFilterOption
}

export interface GetCostsFiltersSuccess {
  type: constants.GET_COSTS_FILTERS_SUCCESS
  filters: ICostFilter[]
}

export interface ClearCostFilters {
  type: constants.CLEAR_COST_FILTERS
}

export interface SortCosts {
  type: constants.SORT_COSTS
  sorting: ICostSorting
}

export interface SortDcInDanger {
  type: constants.SORT_DC_IN_DANGER
  sorting: ICostSorting
}

export interface SearchCosts {
  type: constants.SEARCH_COSTS
  filter: ICostSearch
}

export interface SetOpenCostDetailsModal {
  type: constants.SET_OPEN_COST_DETAILS_MODAL
  open: boolean
}

export interface UpdateDirectCostSuccess {
  type: constants.UPDATE_DIRECT_COST_SUCCESS
  cost: IDirectCost
}

export interface UpdatePassTroughCostSuccess {
  type: constants.UPDATE_PASS_TROUGH_COST_SUCCESS
  cost: IPassThroughCost
}

export interface CreateDirectCostSuccess {
  type: constants.CREATE_DIRECT_COST_SUCCESS
  cost: IDirectCost
}

export interface CreatePassTroughCostSuccess {
  type: constants.CREATE_PASS_TROUGH_COST_SUCCESS
  cost: IPassThroughCost
}

export interface GetDirectCostHistorySuccess {
  type: constants.GET_DIRECT_COST_HISTORY_SUCCESS
  history: ICostHistory[]
}

export interface ResetDirectCostHistory {
  type: constants.RESET_DIRECT_COST_HISTORY
}

export interface GetPassTroughCostHistorySuccess {
  type: constants.GET_PASS_TROUGH_COST_HISTORY_SUCCESS
  history: ICostHistory[]
}

export interface ResetPassTroughCostHistory {
  type: constants.RESET_PASS_TROUGH_COST_HISTORY
}

export interface UpdateDirectCostsSuccess {
  type: constants.UPDATE_DIRECT_COSTS_SUCCESS
  costs: IOfferDirectCost[]
}

export interface SetBulkDirectCosts {
  type: constants.SET_BULK_DIRECT_COSTS
  costs: IDirectCostsBulk
}

export interface SetOfferBulkDirectCosts {
  type: constants.SET_OFFER_BULK_DIRECT_COSTS
  costs: IOfferDirectCostsBulk
}

export interface UpdatePassTroughCostsSuccess {
  type: constants.UPDATE_PASS_TROUGH_COSTS_SUCCESS
  costs: IOfferPassThroughCost[]
}

export interface SetBulkPassTroughCosts {
  type: constants.SET_BULK_PASS_TROUGH_COSTS
  costs: IPassTroughCostsBulk
}

export interface SetOfferBulkPassThroughCosts {
  type: constants.SET_OFFER_BULK_PASS_THROUGH_COSTS
  costs: IOfferPassThroughCostsBulk
}

export interface ProjectLabelMergeTasksDirecCostsSuccess {
  type: constants.PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS_SUCCESS
  direct_costs: IDirectCost[]
}

export interface SetActiveSPTBudgetTab {
  type: constants.SET_ACTIVE_SPT_BUDGET_TAB
  tab: string
}

export interface GetOfferDirectCostsSuccess {
  type: constants.GET_OFFER_DIRECT_COSTS_SUCCESS
  offer_direct_costs: IOfferDirectCost[]
}

export interface GetOfferPassTroughCostsSuccess {
  type: constants.GET_OFFER_PASS_TROUGH_COSTS_SUCCESS
  offer_pass_trough_costs: IOfferPassThroughCost[]
}

export interface DeleteOfferVersionSuccess {
  type: constants.DELETE_OFFER_VERSION_SUCCESS
  offer: IProjectOffer
}

export interface SetDraggableIndicatorSuccess {
  type: constants.SET_DRAGGABLE_INDICATOR_SUCCESS
  draggable: boolean
}

export interface MilestoneView {
  type: constants.SET_MILESTONE_VIEW_SUCCESS
  view: 'overview' | 'unit_tracker'
}

export interface SortMilestoneClusteredTasks {
  type: constants.SET_MILESTONE_SORT_SUCCESS
  sort: IMilestoneSortColumn
}

export interface GetMilestoneOfferDirectCostsSuccess {
  type: constants.GET_MILESTONE_OFFER_DIRECT_COSTS_SUCCESS
  tasks: IMilestoneOfferDirectCost[]
}

export interface GetMilestonesSuccess {
  type: constants.GET_MILESTONES_SUCCESS
  milestones: IMilestone[]
}

export interface DeleteMilestoneSuccess {
  type: constants.DELETE_MILESTONE_SUCCESS
  milestone: IMilestone
}

export interface GetMilestoneSuccess {
  type: constants.GET_MILESTONE_SUCCESS
  milestone: IMilestone
}

export interface CreateMilestoneSuccess {
  type: constants.CREATE_MILESTONE_SUCCESS
  milestone: IMilestone
}

export interface UpdateMilestoneSuccess {
  type: constants.UPDATE_MILESTONE_SUCCESS
  milestone: IMilestone
}

export interface SetMilestoneOfferDirectCostsForUpdate {
  type: constants.SET_MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS
  tasks: IMilestoneOfferDirectCostUpdate[]
}

export interface MilestoneOfferDirectCostsUpdateSuccess {
  type: constants.MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS
  tasks: IMilestoneOfferDirectCost[]
}

export interface MilestoneOfferDirectCostsReset {
  type: constants.MILESTONE_OFFER_DIRECT_COSTS_RESET
  tasks: IMilestoneOfferDirectCost[]
}

export interface GetMilestoneUnitTrackerSuccess {
  type: constants.GET_MILESTONE_UNIT_TRACKER_SUCCESS
  tracker: IMilestoneOfferDirectCostMonths[]
}

export const costHasErrored = (hasErrored: boolean, error: Error, action?: string): CostsHasErrored => {
  if (error && action) {
    const errorMsg = error.message
    toastMsg(errorMsg, action, 'error')
  }
  return {
    type: constants.COST_HAS_ERRORED,
    hasErrored: hasErrored
  }
}

export const getDirectCosts: ActionCreator<DirectAndPassTroughCostThunkResult<IDirectCost[]>>
  = (id: string | number, queryParams?: Record<string, string>): DirectAndPassTroughCostThunkResult<IDirectCost[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getDirectCosts(id, queryParams)
        .then(response => {
          dispatch(getDirectCostsSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_DIRECT_COSTS))
          return {} as IDirectCost[]
        })
    }
  }

export const getDirectCostsSuccess = (direct_costs: IDirectCost[]): GetDirectCostsSuccess => {
  return {
    type: constants.GET_DIRECT_COSTS_SUCCESS,
    direct_costs
  }
}

export const getPaginatedDirectCosts: ActionCreator<DirectAndPassTroughCostThunkResult<IPagination<IDirectCost[]>>>
  = (id: string | number, queryParams: Record<string, string>): DirectAndPassTroughCostThunkResult<IPagination<IDirectCost[]>> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getPaginatedDirectCosts(id, queryParams)
        .then(response => {
          dispatch(getPaginatedDirectCostsSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_PAGINATED_DIRECT_COSTS))
          return {} as IPagination<IDirectCost[]>
        })
    }
  }


export const getPaginatedDirectCostsSuccess = (direct_costs: IPagination<IDirectCost[]>): GetPaginatedDirectCostsSuccess => {
  return {
    type: constants.GET_PAGINATED_DIRECT_COSTS_SUCCESS,
    direct_costs
  }
}

export const setPaginatedDirectCostsActivePage = (page: number): SetPaginatedDirectCostsActivePage => {
  return {
    type: constants.SET_PAGINATED_DIRECT_COSTS_ACTIVE_PAGE,
    page: page
  }
}

export const getDirectCost: ActionCreator<DirectAndPassTroughCostThunkResult<IDirectCost>>
  = (projectId: string | number, cost: IDirectCost): DirectAndPassTroughCostThunkResult<IDirectCost> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getDirectCost(projectId, cost)
        .then(response => {
          dispatch(getDirectCostSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_DIRECT_COST))
          return {} as IDirectCost
        })
    }
  }

export const getDirectCostSuccess = (cost: IDirectCost): GetDirectCostSuccess => {
  return {
    type: constants.GET_DIRECT_COST_SUCCESS,
    cost
  }
}

export const getPassTroughCosts: ActionCreator<DirectAndPassTroughCostThunkResult<IPassThroughCost[]>>
  = (id: string | number, queryParams?: Record<string, string>): DirectAndPassTroughCostThunkResult<IPassThroughCost[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getPassTroughCosts(id, queryParams)
        .then(response => {
          dispatch(getPassTroughCostsSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_PASS_TROUGH_COSTS))
          return {} as IPassThroughCost[]
        })
    }
  }

export const getPassTroughCostsSuccess = (pass_trough_costs: IPassThroughCost[]): GetPassTroughCostsSuccess => {
  return {
    type: constants.GET_PASS_TROUGH_COSTS_SUCCESS,
    pass_trough_costs
  }
}

export const getOfferDirectCosts: ActionCreator<DirectAndPassTroughCostThunkResult<IOfferDirectCost[]>>
  = (id: string | number, offer_id: string | number, queryParams?: Record<string, string>): DirectAndPassTroughCostThunkResult<IOfferDirectCost[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getOfferDirectCosts(id, offer_id, queryParams)
        .then(response => {
          dispatch(getOfferDirectCostsSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_OFFER_PASS_TROUGH_COSTS))
          return {} as IOfferDirectCost[]
        })
    }
  }

export const getOfferDirectCostsSuccess = (offer_direct_costs: IOfferDirectCost[]): GetOfferDirectCostsSuccess => {
  return {
    type: constants.GET_OFFER_DIRECT_COSTS_SUCCESS,
    offer_direct_costs
  }
}

export const getOfferPassTroughCosts: ActionCreator<DirectAndPassTroughCostThunkResult<IOfferPassThroughCost[]>>
  = (id: string | number, offer_id: string | number, queryParams?: Record<string, string>): DirectAndPassTroughCostThunkResult<IOfferPassThroughCost[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getOfferPassTroughCosts(id, offer_id, queryParams)
        .then(response => {
          dispatch(getOfferPassTroughCostsSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_OFFER_PASS_TROUGH_COSTS))
          return {} as IOfferPassThroughCost[]
        })
    }
  }

export const getOfferPassTroughCostsSuccess = (offer_pass_trough_costs: IOfferPassThroughCost[]): GetOfferPassTroughCostsSuccess => {
  return {
    type: constants.GET_OFFER_PASS_TROUGH_COSTS_SUCCESS,
    offer_pass_trough_costs
  }
}

export const getPassTroughCost: ActionCreator<DirectAndPassTroughCostThunkResult<IPassThroughCost>>
  = (projectId: string | number, cost: IPassThroughCost): DirectAndPassTroughCostThunkResult<IPassThroughCost> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getPassTroughCost(projectId, cost)
        .then(response => {
          dispatch(getPassTroughCostSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_PASS_TROUGH_COST))
          return {} as IPassThroughCost
        })
    }
  }

export const getPassTroughCostSuccess = (cost: IPassThroughCost): GetPassTroughCostSuccess => {
  return {
    type: constants.GET_PASS_TROUGH_COST_SUCCESS,
    cost
  }
}

export const setSelectedCost = (cost: IDirectCost | IPassThroughCost): SetSelectedCost => {
  return {
    type: constants.SET_SELECTED_COST,
    cost
  }
}

export const setCostFilters = (filter: ICostFilter, queryOptions: ICostFilterOption): SetCostsFilters => {
  return {
    type: constants.SET_COSTS_FILTERS,
    filter,
    queryOptions
  }
}

export const getCostFilters: ActionCreator<DirectAndPassTroughCostThunkResult<ICostFilter[]>>
  = (id: string | number): DirectAndPassTroughCostThunkResult<ICostFilter[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getDirectOrPassTroughCostsFilters(id)
        .then(response => {
          dispatch(getCostFiltersSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_COSTS_FILTERS))
          return [] as ICostFilter[]
        })
    }
  }

export const getCostFiltersSuccess = (filters: ICostFilter[]): GetCostsFiltersSuccess => {
  return {
    type: constants.GET_COSTS_FILTERS_SUCCESS,
    filters
  }
}

export const clearCostFilters = (): ClearCostFilters => {
  return {
    type: constants.CLEAR_COST_FILTERS
  }
}

export const sortCosts = (sorting: ICostSorting): SortCosts => {
  return {
    type: constants.SORT_COSTS,
    sorting
  }
}

export const sortDcInDanger = (sorting: ICostSorting): SortDcInDanger => {
  return {
    type: constants.SORT_DC_IN_DANGER,
    sorting
  }
}

export const searchCosts = (filter: ICostSearch): SearchCosts => {
  return {
    type: constants.SEARCH_COSTS,
    filter
  }
}

export const setOpenCostDetailsModal = (open: boolean): SetOpenCostDetailsModal => {
  return {
    type: constants.SET_OPEN_COST_DETAILS_MODAL,
    open
  }
}

export const createDirectCost: ActionCreator<DirectAndPassTroughCostThunkResult<IDirectCost>>
  = (projectId: string | number, cost: IDirectCost): DirectAndPassTroughCostThunkResult<IDirectCost> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.createDirectCost(projectId, cost)
        .then(response => {
          dispatch(createDirectCostSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.CREATE_DIRECT_COST))
          return {} as IDirectCost
        })
    }
  }

export const createDirectCostSuccess = (cost: IDirectCost): CreateDirectCostSuccess => {
  toastMsg(`Create ${cost.offer_position} successfully.`, constants.CREATE_DIRECT_COST_SUCCESS, 'success')
  return {
    type: constants.CREATE_DIRECT_COST_SUCCESS,
    cost
  }
}

export const updateDirectCost: ActionCreator<DirectAndPassTroughCostThunkResult<IDirectCost>>
  = (projectId: string | number, cost: IDirectCost, changed?: string): DirectAndPassTroughCostThunkResult<IDirectCost> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.updateDirectCost(projectId, cost)
        .then(response => {
          dispatch(updateDirectCostSuccess(response, changed))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.UPDATE_DIRECT_COST))
          return {} as IDirectCost
        })
    }
  }

export const updateDirectCostSuccess = (cost: IDirectCost, changed?: string): UpdateDirectCostSuccess => {
  if (changed === 'completed') {
    toastMsg(`${cost.offer_position}  was marked as done.`, constants.UPDATE_DIRECT_COST_SUCCESS, 'success')
  } else if (changed === 'in_progress') {
    toastMsg(`${cost.offer_position}  was marked as undone.`, constants.UPDATE_DIRECT_COST_SUCCESS, 'success')
  } else {
    toastMsg(`Updated ${cost.offer_position} data successfully.`, constants.UPDATE_DIRECT_COST_SUCCESS, 'success')
  }

  return {
    type: constants.UPDATE_DIRECT_COST_SUCCESS,
    cost
  }
}

export const updatePassTroughCost: ActionCreator<DirectAndPassTroughCostThunkResult<IPassThroughCost>>
  = (projectId: string | number, cost: IPassThroughCost): DirectAndPassTroughCostThunkResult<IPassThroughCost> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.updatePassTroughCost(projectId, cost)
        .then(response => {
          dispatch(updatePassTroughCostSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.UPDATE_PASS_TROUGH_COST))
          return {} as IPassThroughCost
        })
    }
  }

export const updatePassTroughCostSuccess = (cost: IPassThroughCost): UpdatePassTroughCostSuccess => {
  toastMsg(`Updated ${cost.offer_position} data successfully.`, constants.UPDATE_PASS_TROUGH_COST_SUCCESS, 'success')
  return {
    type: constants.UPDATE_PASS_TROUGH_COST_SUCCESS,
    cost
  }
}

export const createPassTroughCost: ActionCreator<DirectAndPassTroughCostThunkResult<IPassThroughCost>>
  = (projectId: string | number, cost: IPassThroughCost): DirectAndPassTroughCostThunkResult<IPassThroughCost> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.createPassTroughCost(projectId, cost)
        .then(response => {
          dispatch(createPassTroughCostSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.CREATE_PASS_TROUGH_COST))
          return {} as IPassThroughCost
        })
    }
  }

export const createPassTroughCostSuccess = (cost: IPassThroughCost): CreatePassTroughCostSuccess => {
  toastMsg(`Create ${cost.offer_position} successfully.`, constants.CREATE_PASS_TROUGH_COST_SUCCESS, 'success')
  return {
    type: constants.CREATE_PASS_TROUGH_COST_SUCCESS,
    cost
  }
}

export const getDirectCostHistory: ActionCreator<DirectAndPassTroughCostThunkResult<ICostHistory[]>>
  = (projectId: string | number, cost: IDirectCost, search: string): DirectAndPassTroughCostThunkResult<ICostHistory[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getDirectCostHistory(projectId, cost, search)
        .then(response => {
          dispatch(getDirectCostHistorySuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_DIRECT_COST_HISTORY))
          return {} as ICostHistory[]
        })
    }
  }

export const getDirectCostHistorySuccess = (history: ICostHistory[]): GetDirectCostHistorySuccess => {
  return {
    type: constants.GET_DIRECT_COST_HISTORY_SUCCESS,
    history
  }
}

export const resetDirectCostHistory = (): ResetDirectCostHistory => {
  return {
    type: constants.RESET_DIRECT_COST_HISTORY
  }
}

export const getPassTroughCostHistory: ActionCreator<DirectAndPassTroughCostThunkResult<ICostHistory[]>>
  = (projectId: string | number, cost: IPassThroughCost, search: string): DirectAndPassTroughCostThunkResult<ICostHistory[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getPassTroughCostHistory(projectId, cost, search)
        .then(response => {
          dispatch(getPassTroughCostHistorySuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_PASS_TROUGH_COSTS))
          return {} as ICostHistory[]
        })
    }
  }

export const getPassTroughCostHistorySuccess = (history: ICostHistory[]): GetPassTroughCostHistorySuccess => {
  return {
    type: constants.GET_PASS_TROUGH_COST_HISTORY_SUCCESS,
    history
  }
}

export const resetPassTroughCostHistory = (): ResetPassTroughCostHistory => {
  return {
    type: constants.RESET_PASS_TROUGH_COST_HISTORY
  }
}

export const updateOfferDirectCosts: ActionCreator<DirectAndPassTroughCostThunkResult<IOfferDirectCost[]>>
  = (projectId: string | number, offer_id: string | number, costs: IOfferDirectCostsBulk): DirectAndPassTroughCostThunkResult<IOfferDirectCost[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.updateOfferDirectCosts(projectId, offer_id, costs)
        .then(response => {
          dispatch(updateDirectCostsSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.UPDATE_DIRECT_COSTS))
          return Promise.reject(error)
        })
    }
  }

export const updateDirectCostsSuccess = (costs: IOfferDirectCost[]): UpdateDirectCostsSuccess => {
  toastMsg(`Updated costs successfully.`, constants.UPDATE_DIRECT_COSTS_SUCCESS, 'success')
  return {
    type: constants.UPDATE_DIRECT_COSTS_SUCCESS,
    costs
  }
}

export const setBulkDirectCosts = (costs: IDirectCostsBulk): SetBulkDirectCosts => {
  return {
    type: constants.SET_BULK_DIRECT_COSTS,
    costs
  }
}

export const setOfferBulkDirectCosts = (costs: IOfferDirectCostsBulk): SetOfferBulkDirectCosts => {
  return {
    type: constants.SET_OFFER_BULK_DIRECT_COSTS,
    costs
  }
}

export const updateOfferPassTroughCosts: ActionCreator<DirectAndPassTroughCostThunkResult<IOfferPassThroughCost[]>>
  = (projectId: string | number, offer_id: string | number, costs: IOfferPassThroughCostsBulk): DirectAndPassTroughCostThunkResult<IOfferPassThroughCost[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.updateOfferPassTroughCosts(projectId, offer_id, costs)
        .then(response => {
          dispatch(updateOfferPassTroughCostsSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.UPDATE_PASS_TROUGH_COSTS))
          return {} as IOfferPassThroughCost[]
        })
    }
  }

export const updateOfferPassTroughCostsSuccess = (costs: IOfferPassThroughCost[]): UpdatePassTroughCostsSuccess => {
  toastMsg(`Updated costs successfully.`, constants.UPDATE_PASS_TROUGH_COSTS_SUCCESS, 'success')
  return {
    type: constants.UPDATE_PASS_TROUGH_COSTS_SUCCESS,
    costs
  }
}

export const setBulkPassTroughCosts = (costs: IPassTroughCostsBulk): SetBulkPassTroughCosts => {
  return {
    type: constants.SET_BULK_PASS_TROUGH_COSTS,
    costs
  }
}

export const setBulkPassThroughCosts = (costs: IOfferPassThroughCostsBulk): SetOfferBulkPassThroughCosts => {
  return {
    type: constants.SET_OFFER_BULK_PASS_THROUGH_COSTS,
    costs
  }
}

export const deleteProjectOffer: ActionCreator<DirectAndPassTroughCostThunkResult<string | number | void>
> = (projectId: string | number, offer: IProjectOffer): DirectAndPassTroughCostThunkResult<string | number | void> => {
  return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
    return ProjectsApi.deleteProjectOffer(projectId, offer)
      .then(response => {
        dispatch(deleteOfferSuccess(offer))
        return response
      })
      .catch(error => {
        dispatch(costHasErrored(true, error.response.data, constants.DELETE_OFFER_VERSION))
      })
  }
}

export const deleteOfferSuccess = (offer: IProjectOffer): DeleteOfferVersionSuccess => {
  toastMsg(`Deleted ${offer.version} project offer successfully.`, constants.DELETE_OFFER_VERSION_SUCCESS, 'success')
  return {
    type: constants.DELETE_OFFER_VERSION_SUCCESS,
    offer
  }
}

export const mergeActivitiesWithLabelDirectCost: ActionCreator<DirectAndPassTroughCostThunkResult<IDirectCost[]>>
  = (projectId: string | number, activitiesBulk: ILabelMergeTasksBulk): DirectAndPassTroughCostThunkResult<IDirectCost[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.mergeProjectTaskWithLabelsDirectCost(projectId, activitiesBulk)
        .then(response => {
          dispatch(mergeActivitiesWithLabelDirectCostSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS))
          return {} as IDirectCost[]
        })
    }
  }

export const mergeActivitiesWithLabelDirectCostSuccess = (direct_costs: IDirectCost[]): ProjectLabelMergeTasksDirecCostsSuccess => {
  toastMsg(`Tasks successfully merged with label.`, constants.PROJECT_LABELS_MERGE_TASKS_SUCCESS, 'success')
  return {
    type: constants.PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS_SUCCESS,
    direct_costs
  }
}

export const setActiveSPTBudgetTab = (tab: string): SetActiveSPTBudgetTab => {
  return {
    type: constants.SET_ACTIVE_SPT_BUDGET_TAB,
    tab
  }
}

export const setDraggableIndicator = (draggable: boolean): SetDraggableIndicatorSuccess => {
  return {
    type: constants.SET_DRAGGABLE_INDICATOR_SUCCESS,
    draggable
  }
}

export const setMilestoneView = (view: 'overview' | 'unit_tracker'): MilestoneView => {
  return {
    type: constants.SET_MILESTONE_VIEW_SUCCESS,
    view
  }
}

export const sortMilestoneClusteredTasks = (sort: IMilestoneSortColumn): SortMilestoneClusteredTasks => {
  return {
    type: constants.SET_MILESTONE_SORT_SUCCESS,
    sort
  }
}

export const getMilestoneOfferDirectCosts: ActionCreator<DirectAndPassTroughCostThunkResult<IMilestoneOfferDirectCost[]>>
  = (id: number, queryParams?: Record<string, string>): DirectAndPassTroughCostThunkResult<IMilestoneOfferDirectCost[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getMilestoneOfferDirectCosts(id, queryParams)
        .then(response => {
          dispatch(getMilestoneOfferDirectCostsSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_MILESTONE_OFFER_DIRECT_COSTS))
          return [] as IMilestoneOfferDirectCost[]
        })
    }
  }

export const getMilestoneOfferDirectCostsSuccess = (tasks: IMilestoneOfferDirectCost[]): GetMilestoneOfferDirectCostsSuccess => {
  return {
    type: constants.GET_MILESTONE_OFFER_DIRECT_COSTS_SUCCESS,
    tasks
  }
}

export const getMilestones: ActionCreator<DirectAndPassTroughCostThunkResult<IMilestone[]>>
  = (id: number, queryParams?: Record<string, string>): DirectAndPassTroughCostThunkResult<IMilestone[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getProjectMilestones(id, queryParams)
        .then(response => {
          dispatch(getMilestonesSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_MILESTONES))
          return [] as IMilestone[]
        })
    }
  }

export const getMilestonesSuccess = (milestones: IMilestone[]): GetMilestonesSuccess => {
  return {
    type: constants.GET_MILESTONES_SUCCESS,
    milestones
  }
}

export const deleteMilestone: ActionCreator<DirectAndPassTroughCostThunkResult<number | void>>
  = (milestone: IMilestone): DirectAndPassTroughCostThunkResult<number | void> => {
  return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
    return ProjectsApi.deleteMilestone(milestone.id)
      .then(response => {
        dispatch(deleteMilestoneSuccess(milestone))
        return response
      })
      .catch(error => {
        dispatch(costHasErrored(true, error.response.data, constants.DELETE_MILESTONE))
      })
  }
}

export const deleteMilestoneSuccess = (milestone: IMilestone): DeleteMilestoneSuccess => {
  toastMsg(`Deleted ${milestone.name} milestone successfully.`, constants.DELETE_OFFER_VERSION_SUCCESS, 'success')
  return {
    type: constants.DELETE_MILESTONE_SUCCESS,
    milestone
  }
}

export const getMilestone: ActionCreator<DirectAndPassTroughCostThunkResult<IMilestone>>
  = (id: number): DirectAndPassTroughCostThunkResult<IMilestone> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getMilestone(id)
        .then(response => {
          dispatch(getMilestoneSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_MILESTONE))
          return {} as IMilestone
        })
    }
  }

export const getMilestoneSuccess = (milestone: IMilestone): GetMilestoneSuccess => {
  return {
    type: constants.GET_MILESTONE_SUCCESS,
    milestone
  }
}

export const createMilestone: ActionCreator<DirectAndPassTroughCostThunkResult<IMilestone>>
  = (projectId: number, milestone: IMilestone): DirectAndPassTroughCostThunkResult<IMilestone> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.createMilestone(projectId, milestone)
        .then(response => {
          dispatch(createMilestoneSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.CREATE_MILESTONE))
          return {} as IMilestone
        })
    }
  }

export const createMilestoneSuccess = (milestone: IMilestone): CreateMilestoneSuccess => {
  toastMsg(`Create ${milestone.name} successfully.`, constants.CREATE_MILESTONE_SUCCESS, 'success')
  return {
    type: constants.CREATE_MILESTONE_SUCCESS,
    milestone
  }
}

export const updateMilestone: ActionCreator<DirectAndPassTroughCostThunkResult<IMilestone>>
  = (milestone: IMilestone): DirectAndPassTroughCostThunkResult<IMilestone> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.updateMilestone(milestone)
        .then(response => {
          dispatch(updateMilestoneSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.UPDATE_MILESTONE))
          return {} as IMilestone
        })
    }
  }

export const updateMilestoneSuccess = (milestone: IMilestone): UpdateMilestoneSuccess => {
  toastMsg(`Updated ${milestone.name} milestone successfully.`, constants.UPDATE_MILESTONE_SUCCESS, 'success')
  return {
    type: constants.UPDATE_MILESTONE_SUCCESS,
    milestone
  }
}

export const setMilestoneOfferDirectCostsForUpdate = (tasks: IMilestoneOfferDirectCostUpdate[]): SetMilestoneOfferDirectCostsForUpdate => {
  return {
    type: constants.SET_MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS,
    tasks
  }
}

export const milestoneOfferDirectCostsUpdate: ActionCreator<DirectAndPassTroughCostThunkResult<IMilestoneOfferDirectCost[]>>
  = (id: number, tasks: IMilestoneOfferDirectCostUpdate[]): DirectAndPassTroughCostThunkResult<IMilestoneOfferDirectCost[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.updateMilestoneOfferDirectCosts(id, tasks)
        .then(response => {
          dispatch(milestoneOfferDirectCostsUpdateSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.MILESTONE_OFFER_DIRECT_COSTS_UPDATE))
          return [] as IMilestoneOfferDirectCost[]
        })
    }
  }

export const milestoneOfferDirectCostsUpdateSuccess = (tasks: IMilestoneOfferDirectCost[]): MilestoneOfferDirectCostsUpdateSuccess => {
  toastMsg(`Updated milestone tasks successfully.`, constants.MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS, 'success')
  return {
    type: constants.MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS,
    tasks
  }
}

export const milestoneOfferDirectCostsReset = (tasks: IMilestoneOfferDirectCost[]): MilestoneOfferDirectCostsReset => {
  return {
    type: constants.MILESTONE_OFFER_DIRECT_COSTS_RESET,
    tasks
  }
}

export const getMilestoneUnitTracker: ActionCreator<DirectAndPassTroughCostThunkResult<IMilestoneOfferDirectCostMonths[]>>
  = (id: number, queryParams?: Record<string, string>): DirectAndPassTroughCostThunkResult<IMilestoneOfferDirectCostMonths[]> => {
    return async (dispatch: DirectAndPassTroughCostThunkDispatchType) => {
      return ProjectsApi.getProjectMilestonesUnitTracker(id, queryParams)
        .then(response => {
          dispatch(getMilestoneUnitTrackerSuccess(response))
          return response
        })
        .catch(error => {
          dispatch(costHasErrored(true, error.response.data, constants.GET_MILESTONE_UNIT_TRACKER))
          return [] as IMilestoneOfferDirectCostMonths[]
        })
    }
  }

export const getMilestoneUnitTrackerSuccess = (tracker: IMilestoneOfferDirectCostMonths[]): GetMilestoneUnitTrackerSuccess => {
  return {
    type: constants.GET_MILESTONE_UNIT_TRACKER_SUCCESS,
    tracker
  }
}

export type DirectAndPassTroughCostActions
  = GetDirectCostsSuccess
  | GetPassTroughCostsSuccess
  | SetSelectedCost
  | SetCostsFilters
  | GetCostsFiltersSuccess
  | ClearCostFilters
  | SortCosts
  | SearchCosts
  | SetOpenCostDetailsModal
  | GetDirectCostSuccess
  | GetPassTroughCostSuccess
  | UpdateDirectCostSuccess
  | CreateDirectCostSuccess
  | UpdatePassTroughCostSuccess
  | CreatePassTroughCostSuccess
  | GetDirectCostHistorySuccess
  | ResetDirectCostHistory
  | GetPassTroughCostHistorySuccess
  | ResetPassTroughCostHistory
  | CostsHasErrored
  | UpdateDirectCostsSuccess
  | SetBulkDirectCosts
  | UpdatePassTroughCostsSuccess
  | SetBulkPassTroughCosts
  | ProjectLabelMergeTasksDirecCostsSuccess
  | SetActiveSPTBudgetTab
  | GetOfferPassTroughCostsSuccess
  | GetOfferDirectCostsSuccess
  | SetOfferBulkDirectCosts
  | SetOfferBulkPassThroughCosts
  | DeleteOfferVersionSuccess
  | SortDcInDanger
  | SetDraggableIndicatorSuccess
  | GetPaginatedDirectCostsSuccess
  | SetPaginatedDirectCostsActivePage
  | MilestoneView
  | SortMilestoneClusteredTasks
  | GetMilestoneOfferDirectCostsSuccess
  | GetMilestonesSuccess
  | DeleteMilestoneSuccess
  | GetMilestoneSuccess
  | CreateMilestoneSuccess
  | UpdateMilestoneSuccess
  | SetMilestoneOfferDirectCostsForUpdate
  | MilestoneOfferDirectCostsUpdateSuccess
  | MilestoneOfferDirectCostsReset
  | GetMilestoneUnitTrackerSuccess
